(() => {
  const forms = document.querySelectorAll('[data-tzc-gateway-form]');
  forms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const status = form.querySelector('[data-form-status]');
      const endpoint = form.dataset.endpoint;
      if (!endpoint) {
        status.textContent = 'This form is not connected yet.';
        return;
      }
      if (!form.reportValidity()) return;
      const button = form.querySelector('[type="submit"]');
      button.disabled = true;
      status.textContent = 'Submitting…';
      const payload = Object.fromEntries(new FormData(form).entries());
      payload.form_source = form.dataset.formSource || 'Till Zero website';
      payload.page_url = window.location.href;
      try {
        const response = await fetch(endpoint, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});
        if (!response.ok) throw new Error('Request failed');
        form.reset();
        status.textContent = form.dataset.success || 'Received. We’ll be in touch.';
      } catch (_) {
        status.textContent = 'We could not submit the form. Please try again.';
      } finally {
        button.disabled = false;
      }
    });
  });
})();

